export enum rampfeeCategoryType {
    aicraft = 2,
    weightRange  = 3,
    wingspan = 4,
    tailnumber = 5,
}
